import React, { useState } from 'react'
import './import-good.scss'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import { Row, Column } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import ShopImport from './shop-import/shop-import'
import TableImport from './table-import/table-import'
import ImportRecord from './import-record/import-record'

interface ImportGoodProps {
    onImport: (recordId: number, cb: () => void) => void
}

const ImportGood: React.FC<ImportGoodProps> = props => {
    const cls = useBemClass('import-good')

    const [activeIndex, setActiveIndex] = useState<number>(0)

    return (
        <BaseDrawer
            isShow
            width={activeIndex === 1 ? 1000 : 700}
            title="批量导入商品"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-height-100p data-width-100p data-align-items-center data-overflow-auto>
                <Row data-align-items-center className={cls('top')}>
                    <div className={cls('cell')}>
                        <div
                            className={cls('cell', activeIndex === 0 ? 'active' : 'unactive')}
                            onClick={() => setActiveIndex(0)}
                        >
                            店铺导入
                        </div>
                        <div
                            className={cls('cell', activeIndex === 1 ? 'active' : 'unactive')}
                            onClick={() => setActiveIndex(1)}
                        >
                            表格导入
                        </div>
                    </div>
                    <div
                        className="action"
                        onClick={() => {
                            showLayer(<ImportRecord />)
                        }}
                    >
                        导入记录
                    </div>
                </Row>
                {activeIndex === 1 ? <TableImport onImport={props.onImport} /> : <ShopImport />}
            </Column>
        </BaseDrawer>
    )
}

export default ImportGood
